export default "__VITE_ASSET__DxjnnPIU__"